/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ELineTypes } from "../../pages/vehiclePrograms/ItemDetails/Tabs/SensingSysPerfTab/constants";

export enum EReportTypes {
  FULL_REPORT = 'Full Report',
  STATIC_REPORT = 'Static Report',
}

export enum EReportSectionTypes {
  BAR_PLOT = 'Bar Plot',
  CARTESIAN_PLOT = 'Cartesian Plot',
  IMAGE = 'Image',
  TABLE = 'Table',
  TEXT = 'Text',
}

export interface IArgosReportSection {
  name: string,
  type: string,
  data: any,
}

export interface IArgosReportSectionProps {
  data: any,
}

interface CartesianPlotData {
  plotTitle?: string,
  xAxisLabel?: string,
  yAxisLabel?: string,
  plot: PlotData[],
}

export interface PlotData {
  line: ELineTypes,
  xData: number[],
  yData: number[],
  graphType?: string,
  graphMode?: string,
}

export interface ICartesianPlotProps {
  data: CartesianPlotData,
}

interface TableDataConfig {
  stickyColumns?: string[],
}

interface TableData {
  columns: string[],
  rows: any[],
  config?: TableDataConfig,
}

export interface ITableProps {
  data: TableData,
}

export interface IHtmlReportSection {
  name: string,
  data: any,
}

export interface ReportTab {
  name: string,
  content: any,
}

export interface ReportData {
  reportId?: string,

  /** Vehicle Programs reports */
  fullReport?: any,
  staticReport?: any,

  /** ADAS Programs reports */
  argosReport?: any
  jamaReport?: any,
}
